import PendoModal from '../../components/modal/pendo-modal.vue.js';
import PendoLoadingIndicator from '../../components/loading-indicator/pendo-loading-indicator.vue.js';
import PendoIcon from '../../components/icon/pendo-icon.vue.js';

const validLoadingStates = ['loading', 'rejected', 'resolved'];
var script = {
  name: 'CsvModal',
  components: {
    PendoModal,
    PendoLoadingIndicator,
    PendoIcon
  },
  props: {
    status: {
      type: String,
      required: true,
      validator(status) {
        const isValid = validLoadingStates.includes(status);
        if (!isValid) {
          console.error(`Status "${status}" is not valid status. Valid status: ${validLoadingStates.join(', ')}`);
          return false;
        }
        return true;
      }
    },
    note: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      actionButtons: [{
        theme: 'app',
        type: 'secondary',
        label: 'Close',
        handler: this.closeModal
      }]
    };
  },
  methods: {
    closeModal() {
      this.$emit('close');
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-csv-modal.vue2.js.map
